module.exports = __webpack_public_path__ + "static/media/eduvate-logo.82f65a09.png";